import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { getSpentPoints, getIgnoredQuestionsValue } from "../selectors/answers.selectors";
import Filter from './Filter';
import StatusHeader from './StatusHeader';

const Status = ({
  lang,
  pointsPerStatement,
  status: itemsToRate,
  user
}) => {
  const [ filterText, setFilterText ] = useState('');
  const judgemental = useSelector(state => state.judgemental)

  const spentPointsArray = useSelector(state => itemsToRate.map((item) => {
    const evalId = item.id;
    const spentPoints = getSpentPoints(state, evalId, 1) + getSpentPoints(state, evalId, 2)  +
        getSpentPoints(state, evalId, 3) + getSpentPoints(state, evalId, 4);

    return { id: evalId, spentPoints: spentPoints };
  }));

  const ignoredQuestionArray = useSelector(state => itemsToRate.map((item) => {
    const evalId = item.id;
    const ignoredQuestionsValues = getIgnoredQuestionsValue(state, evalId, 1, pointsPerStatement)
      + getIgnoredQuestionsValue(state, evalId, 2, pointsPerStatement)
      + getIgnoredQuestionsValue(state, evalId, 3, pointsPerStatement)
      + getIgnoredQuestionsValue(state, evalId, 4, pointsPerStatement);

    return { id: evalId, ignoredQuestionsValues };
  }));

  const onSearchChange = event => setFilterText(event.target.value);

  const filterStatus = status => filterText.length !== 0 ?
    status.filter(statusItem => (statusItem.name &&
        statusItem.name.includes(filterText) ||
        ( statusItem.nickname &&
          statusItem.nickname.includes(filterText)))
    ) :
    status;

  const filteredItemsToRate = filterStatus(itemsToRate);

  const itemsToRateList = filteredItemsToRate.map(s => (
    <Link to={ `/q/${s.id}/1` } key={ s.id }>
      <div className={`col-md-12 col-sm-12 col-xs-12 eval ${s.id === user && 'self'}`}>
        <div class='col-md-6 col-sm-6 col-xs-6 eval-name'>{ s.name } {s.nickname ? `(${s.nickname})` : '' }</div>
        {!judgemental ? (
          <div>
            <div class='col-md-3 col-sm-3 col-xs-3 eval-perc-judgemental'>
                      <span class={s.percentage === 100 ? 'green' : ''}>
                        {s.percentage.toFixed(1)}%
                      </span>
            </div>
            <div className='col-md-3 col-sm-3 col-xs-3 eval-perc-judgemental'>
              {(((spentPointsArray.find(e => e.id === s.id).spentPoints)
                - (ignoredQuestionArray.find(e => e.id === s.id).ignoredQuestionsValues)))}
            </div>
          </div>
        ) : (
          <div class='col-md-6 col-sm-6 col-xs-6 eval-perc' >
                      <span class={ s.percentage === 100 ? 'green' : '' }>
                        { s.percentage.toFixed(1) }%
                      </span>
          </div>
        )}
      </div>
    </Link>
  ));

  return (
    <div>
      <div class='col-md-12 col-sm-12 col-xs-12'>
        <Filter onSearchChange={ onSearchChange } lang={ lang }/>
      </div>
      <div class='col-md-12 col-sm-12 col-xs-12 mar20 status-div'>
        <div class='q-status'>
          <div class='col-lg-12 col-md-12 col-sm-12 col-xs-12' style={{'padding': '0px'}}>
            <StatusHeader judgemental={ judgemental } lang={ lang }/>
            { filteredItemsToRate.length !== 0 ?
              itemsToRateList :
              (
                <div className='col-md-12 col-sm-12 col-xs-12 eval eval-name' key={'nomatches'}>
                  { lang.q360_status_no_matches }
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Status;
